import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-security-questions-confirm',
    template: require('./securityQuestionsDialogConfirm.html')
})

export class SecurityQuestionsConfirmDialog {

    constructor(@Inject(MatDialogRef<SecurityQuestionsConfirmDialog>) public dialogRef: MatDialogRef<SecurityQuestionsConfirmDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
